import type { LucideIcon } from 'lucide-react'

import {
    Cog,
    Layers,
    Lightbulb,
    PawPrint,
    ShieldCheck,
    Sparkles,
    Wind
} from 'lucide-react'

const ICON_RULES: Array<{ keywords: Array<string>, icon: LucideIcon }> = [
    { keywords: ['pet', 'hair', 'dog'], icon: PawPrint },
    { keywords: ['odour', 'odor', 'smell', 'smoke'], icon: Wind },
    { keywords: ['engine'], icon: Cog },
    { keywords: ['headlight', 'light'], icon: Lightbulb },
    { keywords: ['clay'], icon: Layers },
    { keywords: ['ceramic', 'seal', 'wax', 'protect'], icon: ShieldCheck }
]

// Picks a fitting icon for an add-on from words in its name, so new add-ons still get a sensible one.
export const getExtraIcon = (name: string): LucideIcon => {
    const value = name.toLowerCase()

    return ICON_RULES.find(rule => rule.keywords.some(keyword => value.includes(keyword)))?.icon ?? Sparkles
}
